import { cn } from "@hulahoop/ui";
import type { InvestmentState } from "@/domain/investment/types";
import { INVESTMENT_STATE_BAR } from "./investmentStates";

export function InvestmentStateBar({
  state,
  className,
}: {
  state: InvestmentState;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn("h-3.5 w-1 shrink-0 rounded-full", INVESTMENT_STATE_BAR[state], className)}
    />
  );
}
